'use client'

import { useEffect } from 'react'
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { useDispatch, useSelector } from 'react-redux'
import {
  changeContent,
  resetForm,
  setOpenForm,
  selectFormData,
  selectOpenForm,
} from '../../../../../../../../reducers/meeting-type-task/update-cell-content'
import { updateCellContent } from '../../../../../../../../reducers/meeting-type-task/constructor'

export default function UpdateCellContent() {
  const dispatch = useDispatch()

  const formData = useSelector(selectFormData)
  const openUpdateForm = useSelector(selectOpenForm)

  const saveContent = () => {
    dispatch(
      updateCellContent({
        sectionIndex: formData.sectionIndex,
        rowIndex: formData.rowIndex,
        colIndex: formData.colIndex,
        value: formData.content,
      }),
    )
    closeFormPopup()
  }

  const changeContentProcess = (event) => {
    dispatch(changeContent({ content: event.target.value }))
  }

  const closeFormPopup = () => {
    dispatch(setOpenForm({ openForm: false }))
  }

  useEffect(() => {
    return () => {
      dispatch(resetForm())
    }
  }, [])

  return (
    <Dialog open={openUpdateForm} onClose={closeFormPopup} className="relative z-50">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-2xl sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
              <button
                type="button"
                onClick={() => closeFormPopup()}
                className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              >
                <span className="sr-only">Close</span>
                <XMarkIcon aria-hidden="true" className="h-6 w-6" />
              </button>
            </div>
            <div className="sm:flex sm:items-start">
              <div className="mt-3 text-center sm:mt-0 sm:text-left">
                <DialogTitle as="h3" className="text-base leading-6 text-gray-700">
                  Edit <span className={'font-semibold text-gray-700'}>{formData.colName}</span> cell content
                </DialogTitle>
                <div className="mt-2">
                  <p className="text-sm text-gray-500">Here you can view and edit a content for selected cell.</p>
                </div>
              </div>
            </div>
            <div className={'pt-4'}>
              <textarea
                autoFocus={true}
                className={'w-full rounded-md px-4 py-2 border-none ring-1 ring-indigo-100 text-sm text-gray-700'}
                onChange={changeContentProcess}
                rows={6}
                value={formData.content}
                placeholder={'Put the cell content here...'}
              />
            </div>
            <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
              <button
                type="button"
                onClick={saveContent}
                className="inline-flex w-full justify-center rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 sm:ml-3 sm:w-auto"
              >
                Save
              </button>
              <button
                type="button"
                onClick={() => closeFormPopup()}
                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
              >
                Cancel
              </button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  )
}
